import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { RoleService } from './@core/services/role.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild  {
  constructor(private authService: AuthService, 
              private router: Router,
              private roleService: RoleService,
            ) {}

  // canActivate(): boolean {
  //   return this.checkLogin();
  // }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const expectedRole = route.data['role'];
    const userRole = this.roleService.getUserRole();

    // if (userRole && userRole === expectedRole) {
    //   return true;
    // }

    // // Redirect to login or handle unauthorized access
    // this.router.navigate(['/login']);
    // return false;

    if (route.data['role'] && route.data['role'] !== userRole) {
      // Redirect to unauthorized or login page
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }

  canActivateChild(): boolean {
    return this.checkLogin();
  }

  private checkLogin(): boolean {
    if (this.authService.isLoggedIn()) {
      return true; // Allow access
    } else {
      this.router.navigate(['/login']); // Redirect to login
      return false;
    }
  }
}
